import { getAccOrigin } from "@adsk/acs-sc-web-platform-api";

const getSystemUrl = (projectId: string, systemId: string): string =>
  `${getAccOrigin()}/build/assets/projects/${projectId}/systems/${systemId}`;

export default getSystemUrl;
